import './css/App.styl';
import React from 'react';
import {connect} from 'react-redux';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import {Header, Footer} from 'legacy-react-navigation';
import {FuneralHomeHeader, FuneralHomeFooter} from '../shared/library';
import activateOptimizely from '../shared/utilities/activateOptimizely';
import {useLegacyMenus} from '../shared/utilities/personPageType';
import appConfig from '../../appConfig/AppConfig';
const mobileDomain = appConfig().mobileDomain;

/**
 * App module - shared
 * @class  App
 */
class App extends React.Component {
  static propTypes = {
    children: React.PropTypes.object.isRequired,
    headerState: React.PropTypes.object.isRequired,
    footerState: React.PropTypes.object.isRequired,
    isMobile: React.PropTypes.bool.isRequired,
  };

  static defaultProps = {
    isMobile: true,
  };

  /**
   * Lifecycle method
   * @return {undefined} returns nothing
   */
  componentDidMount() {
    activateOptimizely(0, activateOptimizely);
  }

  /**
   * Renders Component
   * @return {JSX} Rendered App Module
   */
  render() {
    const personPageType = _get(
      this.props,
      'person.personLayout.personPageType'
    );

    return useLegacyMenus(personPageType) ? (
      <div>
        {!_isEmpty(this.props.headerState) && (
          <Header
            data={this.props.headerState}
            isMobile={this.props.isMobile}
            mobileDomain={mobileDomain}
          />
        )}
        {this.props.children}
        {!_isEmpty(this.props.footerState) && (
          <Footer data={this.props.footerState} />
        )}
      </div>
    ) : (
      <div>
        {!_isEmpty(this.props.headerState) && (
          <FuneralHomeHeader
            data={this.props.headerState}
            isMobile={this.props.isMobile}
          />
        )}
        {this.props.children}
        {!_isEmpty(this.props.footerState) && (
          <FuneralHomeFooter data={this.props.footerState} />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  headerState: state.headerStore,
  footerState: state.footerStore,
  person: _get(state, 'personStore.person'),
  isMobile: _get(state, 'mobileDetailsStore').any,
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/reactModules/App/App.js